import axios from "~/plugins/axios";

export default {
  validateP12(certificate, password) {
    const url = "/web_api/v1/cert/validate/p12";

    return axios.post(url, {
      certificate,
      password,
    }).then((response) => response.data);
  },
  getP12CertInfo(certificate, password) {
    const url = "/web_api/v1/cert/info/p12";

    return axios.post(url, {
      certificate,
      password,
    }).then((response) => response.data);
  },
  validatePEM(certificate) {
    const url = "/web_api/v1/cert/validate/pem";

    return axios.post(url, {
      certificate,
    }).then((response) => response.data);
  },
  getPEMCertInfo(certificate, password) {
    const url = "/web_api/v1/cert/info/pem";

    return axios.post(url, {
      certificate,
      password,
    }).then((response) => response.data);
  },
};
